import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/components/MsgBox/index'
import '@/components/Loading/index'
import '@/assets/font/iconfont.css'
import * as $http from './utils/fetch'
Vue.config.productionTip = false
Vue.prototype.$http = $http

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /* 路由发生改变修改页面的title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // if (!store.state.userInfo && to.name !== 'login' && to.name !== 'forget') {
  //   next('login')
  //   return
  // }
  // if ((to.name === 'login' || to.name === 'forget') && store.state.userInfo) {
  //   next('index')
  //   return
  // }
  // if (to.name === 'login' || to.name === 'forget') {
  //   store.commit('changeIsShow', false)
  // } else {
  //   store.commit('changeIsShow', true)
  // }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
